import { Datagrid as RaDatagrid } from './Datagrid';
import { styled } from '@mui/material/styles';
import { DatagridProps } from 'react-admin';

const StyledDatagrid = styled(RaDatagrid, { slot: 'root' })(({ theme }) => ({
  '& .RaBulkActionsToolbar-toolbar': {
    height: 48
  },
  // Resolve an issue related to the visualization of the bulk actions toolbar.
  // Padding and margin create a non empty space that allows the toolbar to be displayed when
  // the selection is empty.
  '& .RaBulkActionsToolbar-collapsed': {
    height: 0,
    paddingTop: 0,
    paddingBottom: 0
  },
  '& .RaBulkActionsToolbar-topToolbar': {
    backgroundColor: 'transparent'
  },
  // Resolve a defect related to the usage of AntDesin icons with Mantis and React-Admin.
  // These two lines are not needed if you are not using AntDesign icons.
  '& .icon span': {
    top: -1,
    left: -1
  },
  '& th': {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    backgroundColor: 'inherit !important',
    textTransform: 'none',
    fontSize: theme.typography.subtitle1.fontSize
  }
}));

/**
 * This component is a wrapper of the React-Admin Datagrid component.
 * It is used to customize the Datagrid component.
 * It is used by the List component.
 * It is not meant to be used directly.
 * Thsi version is designed by Applica for Mantis and expose few overrides on css styles based on this theme.
 */
function Datagrid(props: DatagridProps): JSX.Element {
  // @ts-ignore
  return <StyledDatagrid {...props} />;
}

export { Datagrid };
